import { IdleConfig, ModuleIdleConfig } from './idle-logout.service';

/**
 * Configuration for idle logout timeouts for different modules/pages
 * All times are in milliseconds
 */
export const IDLE_LOGOUT_CONFIG: ModuleIdleConfig = {
  // Portal Dashboard - 30 minutes with 5 minute warning
  'portal-dashboard': {
    timeout: 10 * 60 * 1000,
    warningTime: 2 * 60 * 1000,
  },

  // Research Portal - 45 minutes with 10 minute warning (longer for research activities)
  'research-portal': {
    timeout: 45 * 60 * 1000,
    warningTime: 10 * 60 * 1000,
  },

  // Admin Module - 20 minutes with 3 minute warning
  admin: {
    timeout: 20 * 60 * 1000,
    warningTime: 3 * 60 * 1000,
  },

  // Super Admin - 15 minutes with 2 minute warning (shorter for security)
  'super-admin': {
    timeout: 15 * 60 * 1000,
    warningTime: 2 * 60 * 1000,
  },

  // Product Signup - 60 minutes with 15 minute warning (longer for form completion)
  'product-signup': {
    timeout: 60 * 60 * 1000,
    warningTime: 15 * 60 * 1000,
  },

  // Profile Management - 40 minutes with 8 minute warning
  profile: {
    timeout: 40 * 60 * 1000,
    warningTime: 8 * 60 * 1000,
  },

  // Settings - 35 minutes with 7 minute warning
  settings: {
    timeout: 35 * 60 * 1000,
    warningTime: 7 * 60 * 1000,
  },

  // Ledger/Transactions - 25 minutes with 5 minute warning
  ledger: {
    timeout: 25 * 60 * 1000,
    warningTime: 5 * 60 * 1000,
  },

  // Equity Portfolio - 30 minutes with 6 minute warning
  equity: {
    timeout: 30 * 60 * 1000,
    warningTime: 6 * 60 * 1000,
  },

  // Margin Trading - 20 minutes with 4 minute warning (shorter for trading)
  'margin-trading': {
    timeout: 20 * 60 * 1000,
    warningTime: 4 * 60 * 1000,
  },

  // Default configuration - 25 minutes with 5 minute warning
  default: {
    timeout: 25 * 60 * 1000,
    warningTime: 5 * 60 * 1000,
  },
};

/**
 * Events to monitor for user activity
 */
export const USER_ACTIVITY_EVENTS: string[] = [
  'mousedown',
  'mousemove',
  'keypress',
  'scroll',
  'touchstart',
  'click',
  'focus',
  'input',
  'change',
];

/**
 * Environment-specific configurations
 */
export const getEnvironmentConfig = (): ModuleIdleConfig => {
  const isDevelopment = !environment.production;

  if (isDevelopment) {
    // Shorter timeouts for development/testing
    return {
      'portal-dashboard': { timeout: 10 * 60 * 1000, warningTime: 4 * 60 * 1000 },
      'research-portal': { timeout: 10 * 60 * 1000, warningTime: 2 * 60 * 1000 },
      admin: { timeout: 3 * 60 * 1000, warningTime: 30 * 1000 },
      'super-admin': { timeout: 30 * 60 * 1000, warningTime: 30 * 1000 },
      'product-signup': { timeout: 15 * 60 * 1000, warningTime: 3 * 60 * 1000 },
      profile: { timeout: 8 * 60 * 1000, warningTime: 1.5 * 60 * 1000 },
      default: { timeout: 5 * 60 * 1000, warningTime: 1 * 60 * 1000 },
    };
  }

  return IDLE_LOGOUT_CONFIG;
};

// Import environment for production check
import { environment } from '../../environments/environment';
